import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'aura-glowing-gradient-button',
  imports: [RouterLink, MatIconModule],
  templateUrl: './glowing-gradient-button.component.html',
  styleUrl: './glowing-gradient-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlowingGradientButtonComponent {
  readonly routerLink = input.required<string | unknown[]>();
  readonly label = input<string>('Explorer');
  readonly icon = input<string>('compass');
}
